// extracted by mini-css-extract-plugin
export default {"imageWrapper":"wJ-z","twoColumnImage":"xJ-z"};